import React from "react";

const CheckBox = ({
  title,
  onChange,
  checked,
  name,
  labelClassName = '',
  inputClassName = ''
}) => {
  return (
    <div className="flex items-center gap-1 cursor-pointer">
      <input
        type="checkbox"
        onChange={onChange}
        checked={checked}
        id={name}
        name={name}
        className={`form-checkbox cursor-pointer accent-[#672c71] h-4 w-4 ${inputClassName}`}
      />
      <label htmlFor={name} className={`cursor-pointer ${labelClassName}`}>
        {title}
      </label>
    </div>
  );
};

export default CheckBox;
